import React, {useEffect, useState} from "react";
import {useTheme} from "@mui/material/styles";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {useNavigate} from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDInput from "components/MDInput";
import {
  Alert,
  AppBar,
  Card,
  FormControlLabel,
  Snackbar,
  InputLabel,
  Typography,
  MenuItem,
  Select,
  FormControl
} from "@mui/material";
import MDButton from "components/MDButton";
import {PATCH} from "APIclient";
import {useLocation} from "react-router-dom";
import {DataGrid} from "@mui/x-data-grid";
import {column} from "stylis";
import {useMaterialUIController} from "context";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {DemoContainer} from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {GET} from "APIclient";
import {POST} from "APIclient";
import {alignProperty} from "@mui/material/styles/cssUtils";
import {Grid} from "@mui/material";
import properties from "constants/ApplicationConstants";
import {formatDesignation} from "constants/ApplicationConstants";

function formatDate(dateString) {
  const date = new Date(dateString);
  if (isNaN(date)) return "N/A";
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  }).format(date);
}

function Reporting(noGutter) {
  const [controller] = useMaterialUIController();
  const {darkMode} = controller;
  const location = useLocation();
  const [usersState, setUsersState] = useState(location.state);
  const theme = useTheme();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [snakColor, setSnakColor] = useState("");
  const [snakMessage, setSnakMessage] = useState("");
  const fetchUrl = `admin/employee/reporting/${usersState}`;
  const viewUrl = `admin/get-salaries/${usersState}`;
  const [details, setDetails] = useState([]);
  let [data, setData] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [updateFlag, setUpdateFlag] = useState(false);
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);

  const [formData, setFormData] = useState({
    reportingFrom: dayjs(),
    reportingTo: []
  });
  const [errors, setErrors] = useState({
    reportingFrom: "",
    reportingTo: ""
  });

  const validateField = (name, value) => {
    switch (name) {
      case "reportingFrom":
        if (!value || !dayjs(value).isValid()) {
          return "Please select a valid date";
        }
        if (dayjs(value).isBefore(dayjs())) {
          return "Date cannot be in the past";
        }
        return "";
      case "reportingTo":
        if (!value || value.length === 0) {
          return "Please select a reporting manager";
        }
        return "";
      default:
        return "";
    }
  };

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await GET(fetchUrl);
        const data = response?.data?.data.paginatedData;
        setData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const view = async () => {
      try {
        const response = await GET(viewUrl);
        const view = response?.data?.data;
        setDetails(view);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
    view();
  }, [fetchUrl, viewUrl]);

  const formattedDesignation = formatDesignation(details?.designation ?? "-");

  React.useEffect(() => {
    const url = `admin/employeeDetails`;
    const fetchEmployees = async () => {
      try {
        const response = await GET(url);
        if (response.status === 200 && Array.isArray(response.data.data)) {
          // setSnackMessage(response.data.message);
          // setSnackColor("success");
          // setSnackOpen(true);
          setEmployeeList(response.data.data);
        } else {
          setEmployeeList([]);
        }
      } catch (error) {
        console.error("Error fetching employees:", error);
        setEmployeeList([]);
        if (error.response) {
          setSnakMessage(error.response.data.message);
          setSnakColor("error");
          setSnackOpen(true);
        } else {
          setSnakMessage("Error fetching employees data");
          setSnakColor("error");
          setSnackOpen(true);
        }
      }
    };
    fetchEmployees();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const columns = [
    {field: "leaveRequestId", headerName: "ID", width: 100, hide: true},
    {
      align: "center",
      headerAlign: "center",
      field: "startDate",
      headerName: "Start Date",
      width: 200,
      renderCell: params => {
        const formattedDate = formatDate(params.value);
        return formattedDate || " - ";
      }
    },
    {
      field: "endDate",
      align: "center",
      headerAlign: "center",
      headerName: "End Date",
      width: 200,
      renderCell: params => {
        if (params.value === null) {
          return " - ";
        }
        const formattedDate = formatDate(params.value);
        return formattedDate || " - ";
      }
    },
    {
      field: "reportingTo",
      headerName: "Reporting To",
      headerAlign: "center",
      align: "center",
      //   sortable: false,
      width: 200
      //   valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
    },
    {
      field: "addedOn",
      headerName: "Issued On",
      align: "center",
      headerAlign: "center",
      // type: 'number',
      width: 200,
      renderCell: params => {
        const formattedDate = formatDate(params.value);
        return formattedDate || " - ";
      }
    }
  ];

  const handleCloseSnackbar = () => setSnackbar(null);

  const handleChange = event => {
    const {name, value} = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

    if (name === "reportingTo") {
      setIsSaveButtonDisabled(value === "");
    }

    setErrors(prev => ({
      ...prev,
      [name]: validateField(name, value)
    }));
  };

  const handleDateChange = (date, field) => {
    const validDate = date ? dayjs(date) : null;

    setFormData(prev => ({
      ...prev,
      [field]: validDate?.isValid() ? validDate.format("YYYY-MM-DD") : null
    }));

    setErrors(prev => ({
      ...prev,
      [field]: validateField(field, date)
    }));
  };

  const handleSubmit = async () => {
    const newErrors = {
      reportingFrom: validateField("reportingFrom", formData.reportingFrom),
      reportingTo: validateField("reportingTo", formData.reportingTo)
    };
    setErrors(newErrors);

    let reportingTo = parseInt(formData.reportingTo);
    const dt = {
      // empId: usersState,
      reportingFrom: formData.reportingFrom,
      reportingTo: [reportingTo]
    };

    const url = `admin/employee/reporting/${usersState}`;

    try {
      const response = await POST(url, dt);
      if (response?.data?.statusCode === 200) {
        // Successfully updated
        setSnakColor("success");
        setSnakMessage(response?.data?.message);
        setOpen(true);
        const res = await GET(fetchUrl);
        const updatedData = res?.data?.data?.paginatedData || [];
        setData(updatedData);
        setFormData({
          reportingFrom: dayjs(),
          reportingTo: []
        });
        setIsSaveButtonDisabled(true);
        setUpdateFlag(prev => !prev);
      } else {
        setSnakColor("error");
        setSnakMessage("Failed to update permissions");
        setOpen(true);
      }
    } catch (error) {
      console.error("Error updating permissions:", error);
      setSnakColor("error");
      setSnakMessage("Error updating permissions");
      setOpen(true);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox container>
        <AppBar position="static">
          <Card>
            <MDBox
              pt={2}
              mb={0}
              pb={2}
              px={4}
              sx={{borderRadius: "5px", border: "1px solid #D3D3D3"}}
            >
              <Typography variant="h6" color="textPrimary" fontFamily={properties.fontFamily}>
                Employee Reporting Details
              </Typography>

              <MDBox
                pt={2}
                mb={2}
                pb={4}
                px={4}
                mt={1}
                sx={{borderRadius: "5px", border: "1px solid #D3D3D3"}}
              >
                {/* <Typography sx={{fontSize: "16px", fontWeight: "500"}} color="textPrimary">
                  Employee Details
                </Typography> */}
                <MDBox display="flex" flexDirection="column" pt={2}>
                  <Grid container spacing={3} alignItems="center">
                    {/* Row 1: Employee ID & Joining Date */}
                    <Grid item xs={12} sm={6} container alignItems="center">
                      <MDTypography
                        variant="caption"
                        sx={{fontSize: "14px", fontWeight: "500", minWidth: "150px"}}
                      >
                        Employee ID:
                      </MDTypography>
                      <MDTypography variant="caption" sx={{fontSize: "14px", fontWeight: "400"}}>
                        {details ? details.empId : "-"}
                      </MDTypography>
                    </Grid>
                    <Grid item xs={12} sm={6} container alignItems="center">
                      <MDTypography
                        variant="caption"
                        sx={{fontSize: "14px", fontWeight: "500", minWidth: "150px"}}
                      >
                        Joining Date:
                      </MDTypography>
                      <MDTypography variant="caption" sx={{fontSize: "14px", fontWeight: "400"}}>
                        {details && details.joinDate ? formatDate(details.joinDate) : "-"}
                      </MDTypography>
                    </Grid>

                    {/* Row 2: First Name & Middle Name */}
                    <Grid item xs={12} sm={6} container alignItems="center">
                      <MDTypography
                        variant="caption"
                        sx={{fontSize: "14px", fontWeight: "500", minWidth: "150px"}}
                      >
                        First Name:
                      </MDTypography>
                      <MDTypography variant="caption" sx={{fontSize: "14px", fontWeight: "400"}}>
                        {details ? details.firstName : "-"}
                      </MDTypography>
                    </Grid>
                    <Grid item xs={12} sm={6} container alignItems="center">
                      <MDTypography
                        variant="caption"
                        sx={{fontSize: "14px", fontWeight: "500", minWidth: "150px"}}
                      >
                        Middle Name:
                      </MDTypography>
                      <MDTypography variant="caption" sx={{fontSize: "14px", fontWeight: "400"}}>
                        {details ? details.middleName : "-"}
                      </MDTypography>
                    </Grid>

                    {/* Row 3: Last Name & Designation */}
                    <Grid item xs={12} sm={6} container alignItems="center">
                      <MDTypography
                        variant="caption"
                        sx={{fontSize: "14px", fontWeight: "500", minWidth: "150px"}}
                      >
                        Last Name:
                      </MDTypography>
                      <MDTypography variant="caption" sx={{fontSize: "14px", fontWeight: "400"}}>
                        {details ? details.lastName : "-"}
                      </MDTypography>
                    </Grid>
                    <Grid item xs={12} sm={6} container alignItems="center">
                      <MDTypography
                        variant="caption"
                        sx={{fontSize: "14px", fontWeight: "500", minWidth: "150px"}}
                      >
                        Designation:
                      </MDTypography>
                      <MDTypography variant="caption" sx={{fontSize: "14px", fontWeight: "400"}}>
                        {formattedDesignation}
                      </MDTypography>
                    </Grid>

                    {/* Row 4: Personal Email ID & Official Email ID */}
                    <Grid item xs={12} sm={6} container alignItems="center">
                      <MDTypography
                        variant="caption"
                        sx={{fontSize: "14px", fontWeight: "500", minWidth: "150px"}}
                      >
                        Personal Email ID:
                      </MDTypography>
                      <MDTypography variant="caption" sx={{fontSize: "14px", fontWeight: "400"}}>
                        {details ? details.emailAddress : "-"}
                      </MDTypography>
                    </Grid>
                    <Grid item xs={12} sm={6} container alignItems="center">
                      <MDTypography
                        variant="caption"
                        sx={{fontSize: "14px", fontWeight: "500", minWidth: "150px"}}
                      >
                        Official Email ID:
                      </MDTypography>
                      <MDTypography variant="caption" sx={{fontSize: "14px", fontWeight: "400"}}>
                        {details ? details.officialEmailAddress : "-"}
                      </MDTypography>
                    </Grid>

                    {/* Row 5: Mobile (Single Item) */}
                    <Grid item xs={12} sm={6} container alignItems="center">
                      <MDTypography
                        variant="caption"
                        sx={{fontSize: "14px", fontWeight: "500", minWidth: "150px"}}
                      >
                        Mobile:
                      </MDTypography>
                      <MDTypography variant="caption" sx={{fontSize: "14px", fontWeight: "400"}}>
                        {details ? details.mobileNo : "-"}
                      </MDTypography>
                    </Grid>
                  </Grid>
                </MDBox>
              </MDBox>
              {/* </MDBox> */}
              <DataGrid
                rows={data}
                columns={columns}
                columnVisibilityModel={{
                  leaveRequestId: false
                }}
                getRowId={row => row.leaveRequestId}
                pagination={false}
                rowHeight={35}
                columnHeaderHeight={40}
                hideFooter={data?.length <= 20}
                hideFooterPagination={true}
                sx={{
                  fontFamily: properties.fontFamily,
                  fontSize: "14px",
                  "& .MuiDataGrid-cell": {
                    fontSize: "0.9rem"
                  }
                }}
              />
              <MDBox pt={1} mb={0} pb={4} px={4}>
                {/* <InputLabel sx={{ fontWeight: 'bold', paddingBottom: '20px' }}>Reporting Details</InputLabel> */}
                <Typography variant="h6" color="textPrimary" fontFamily={properties.fontFamily}>
                  Reporting Details
                </Typography>
                <MDBox pt={2}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["DatePicker"]}>
                      <DatePicker
                        format="DD/MM/YYYY"
                        sx={{m: 1, width: "30ch", paddingBottom: "20"}}
                        size="small"
                        label="Applicable From"
                        name="reportingFrom"
                        value={formData ? dayjs(formData.reportingFrom) : null}
                        onChange={date => handleDateChange(date, "reportingFrom")}
                        // minDate={dayjs()}
                        // slotProps={{
                        //   textField: {
                        //     error: !!errors.reportingFrom,
                        //     helperText: errors.reportingFrom
                        //   }
                        // }}
                      />
                      <FormControl
                        variant="standard"
                        sx={{m: 1, width: "30ch", marginLeft: "20px"}}
                      >
                        <InputLabel
                          id="issuedBy"
                          sx={{fontWeight: "bold", fontFamily: properties.fontFamily}}
                        >
                          Reports To <span style={{color: properties.colors.Red}}>*</span>
                        </InputLabel>
                        <Select
                          pb={4}
                          labelId="reportingTo"
                          id="reportingTo"
                          value={formData?.reportingTo}
                          name="reportingTo"
                          onChange={e => handleChange(e)}
                          label="Reporting To"
                        >
                          <MenuItem value="">
                            <em>Select</em>
                          </MenuItem>
                          {employeeList.length > 0 ? (
                            employeeList.map(employee => (
                              <MenuItem key={employee.empId} value={employee.empId}>
                                {employee.firstName} {employee.lastName} [{employee.empId}]
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem disabled>No employees available</MenuItem>
                          )}
                        </Select>
                        {errors.reportingTo && (
                          <MDTypography variant="caption" color="error">
                            {errors.reportingTo}
                          </MDTypography>
                        )}
                      </FormControl>
                    </DemoContainer>

                    {/* </MDBox>
                                    <MDBox pt={2}> */}
                  </LocalizationProvider>
                </MDBox>
              </MDBox>

              <MDBox mt={3} mb={2} sx={{display: "flex", justifyContent: "flex-end"}}>
                <MDBox sx={{display: "flex", gap: 1}}>
                  <MDButton
                    variant="gradient"
                    color="warning"
                    sx={{width: "20ch"}}
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </MDButton>
                  <MDButton
                    variant="gradient"
                    color="info"
                    sx={{
                      width: "20ch",
                      ml: 2,
                      mr: 1,
                      background: properties.colors.bgcolorbluethem
                    }}
                    onClick={() => handleSubmit()}
                    disabled={isSaveButtonDisabled}
                  >
                    Save
                  </MDButton>
                </MDBox>
              </MDBox>

              <Snackbar
                open={open}
                anchorOrigin={{vertical: "top", horizontal: "right"}}
                autoHideDuration={1200}
                onClose={handleClose}
              >
                <Alert
                  onClose={handleClose}
                  severity={snakColor === "success" ? "success" : "error"}
                  variant="filled"
                  sx={{width: "100%", color: "#fff"}}
                >
                  {snakMessage}
                </Alert>
              </Snackbar>
            </MDBox>
          </Card>
        </AppBar>
      </MDBox>
    </DashboardLayout>
  );
}

export default Reporting;
